import React from "react";
import { sumBy, filter } from "lodash";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import FormulaTable from "./FormulaTable";
import { pickMillions, getTeam } from "./utils";
import { moneyFormat } from "./format";
import Auth from "routes/Auth";

const Valuation2 = ({
  teams,
  competitiveAnalysis,
  competitiveAnalysisAll,
  competitionMetrics,
  teamId,
  comparableCompanies,
  constants,
  round
}) => {
  const data = competitiveAnalysis || competitionMetrics;
  const field = "Market Capitalization";
  const team = getTeam(teamId, data);
  const teamRounds = filter(
    competitiveAnalysisAll,
    item => item.team === teamId
  );
  const obj1 = teamRounds.find(i => i.Round === round);
  const netProfits = obj1 && "Net Profits" in obj1 ? obj1["Net Profits"] : 0;
  const peMultiples =
    sumBy(comparableCompanies, "price_to_earnings") /
    comparableCompanies.length;
  const marketCap = team[field];
  const marketCapCalculated = netProfits * peMultiples;
  const minValuation = constants["min_valuation"];

  return (
    <OnePanelChart
      title="Valuation"
      prefix="$"
      suffix="M"
      data={pickMillions(teams, data, field)}
      teams={teams}
    >
      <Text>
        In this round, equity investors used the Price to Earnings Multiples
        (P/E) valuation method to value your business at{" "}
        {moneyFormat(marketCap)}.
      </Text>
      <Text>
        P/E valuation method takes your net income and multiply that by the P/E
        multiple of a comparable company. Here’s the breakdown:
      </Text>
      <FormulaTable
        items={[
          {
            name: "Team Valuation",
            highlighted: true,
            value: moneyFormat(marketCapCalculated)
          },
          { name: "=", highlighted: false, value: "" },
          {
            name: "Net Profits",
            highlighted: true,
            value: moneyFormat(netProfits)
          },
          { name: "×", highlighted: false, value: "" },
          {
            name: "P/E multiples",
            highlighted: true,
            value: peMultiples.toFixed(2)
          }
        ]}
      />
      {marketCapCalculated < minValuation && (
        <Text style={{ marginTop: "1.5em" }}>
          Investors place a minimum value of {moneyFormat(minValuation)} to your
          business.
        </Text>
      )}
    </OnePanelChart>
  );
};

export default Valuation2;



// WEBPACK FOOTER //
// ./src/components/analysis/Valuation2.js